module.exports = {
    calendar: "Kalendár",
    today: "Dnes",
    yesterday: "Včera",
    last7days: "Posledných 7 dní",
    last14days: "Posledných 14 dní",
    delete_all: "Vymazať všetko",
    log_in: "Prihlásiť sa",
    save: "Uložiť",
    close: "Zavrieť",
    today_stats: "dnes",
    week: "týždeň",
    month: "mesiac",
    year: "rok",
    this_year: "Tento rok",
    monthly: "mesačne",
    daily: "denne",
    hourly: "hodinovo",
    add_new_object: "Pridaj nový objekt",
    latitude: "Zemepisná šírka",
    longitude: "Zemepisná dĺžka",
    current_password: "Súčasné heslo",
    new_password: "Nové heslo",
    change_password: "Zmeniť heslo",
    language_select: "Jazyk",
    last_year: "Minulý rok",
    delete: "Zmazať",
    save_profile: "Uložiť profil",
    yes: "Ano",
    cancel: "Zrušiť",
    add_new_group: "Pridaj novú skupinu",
    automatic_learn: "Automaticke učenie",
    delete_all_imprints: "Zmazať všetky odtlačky spotrebičov",
    turn_on: "Zapnúť",
    turn_off: "Vypnúť",
    delete_energy: "Zmazať energiu",
    next: "Ďalej",
    back: "Späť",
    boot_msg: "Správa po štarte",
    force_drsf: "Vynútiť",
    add_test_case: "Pridaj testovací prípad",
    select: "Vyber",
    profile: "Profil",
    group: "Skupina",
    start_test: "Spustiť testovanie",
    generate_new_token: "Generovať nový token",
    generate: "Generovať",
    auto_restart: "Automatický reštart",
    no_group: "Žiadna skupina",
    upgrade: "Aktualizovať",
    upgrade_offline: "Aktualizovať (zariadenie je offline)",
    create_swich: "Pridaj vypínač",
    change_map: "Zmeniť mapu",
    edit_mode: "Editovací mód",
    select_image: "Vyber obrázok",
    add: "Pridaj"
}